import { Component, OnInit } from '@angular/core';
import { Request } from '../core/models/request.model';
import { RequestService } from '../core/services/request.service';
import { ActivatedRoute, Router, RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { SearchParams } from '../core/models/serach-params.model';
import { PersonalDataRequestStatusEnum } from '../core/enums/personal-data-request-status.enum';
import { SideNavigationService } from '../../sb-tools/typescript/services/side-navigation.service';
import { RequestFileStatusEnum } from '../core/enums/request-file-status.enum';
import { InitializationService } from '../core/services/initialization.service';
import { ComponentMessengerService } from '../core/services/component-messenger.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalNewRequestComponent } from '../shared/modals/modal-new-request/modal-new-request.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { SidenavComponent } from '../../sb-tools/typescript/components/sidenav/sidenav.component';
import { NgClass, DatePipe } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { RequestStatusIconComponent } from './request-status-icon/request-status-icon.component';
import { LoaderComponent } from '../../sb-tools/typescript/components/loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
    imports: [
        NavbarComponent,
        SidenavComponent,
        RouterLinkActive,
        RouterLink,
        NgClass,
        InfiniteScrollDirective,
        RequestStatusIconComponent,
        LoaderComponent,
        RouterOutlet,
        DatePipe,
        TranslateModule,
    ],
})
export class RequestsComponent implements OnInit {
    allRequestsRouterLinkActiveOptions: object;
    communityName: string;
    isLoading = false;
    isBackdropShow = '';
    isPhone = false;
    isRequestDetailsShowOnPhone = true;
    isRequestListShowOnPhone = true;

    maxPhoneWidth = 732;
    personalDataRequestStatusEnum = PersonalDataRequestStatusEnum;
    portalName: string;
    requests: Request[];
    requestFileStatusEnum = RequestFileStatusEnum;
    selectedRequest: Request;
    sidebarMode = 'push';
    sidebarAutoCollapseWidth = 1460;

    private searchParams: SearchParams = new SearchParams();
    private searchQuerySubscription: Subscription;
    private messageSubscription: Subscription;

    constructor(
        public sideNavigationService: SideNavigationService,
        private requestService: RequestService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private initializationService: InitializationService,
        private componentMessengerService: ComponentMessengerService,
        private bsModalService: BsModalService,
    ) {
        this.initializationService.portal = activatedRoute.snapshot.data.currentPortal;
        this.portalName = this.initializationService.portal.name;
        this.communityName = this.initializationService.communityName;
        this.requests = [];
    }

    ngOnInit() {
        if (
            window.innerWidth <= this.sidebarAutoCollapseWidth ||
            document.documentElement.clientWidth <= this.sidebarAutoCollapseWidth ||
            document.body.clientWidth <= this.sidebarAutoCollapseWidth
        ) {
            this.sidebarMode = 'over';
            this.isBackdropShow = 'true';
        } else {
            this.sidebarMode = 'push';
            this.isBackdropShow = '';
        }

        if (
            window.innerWidth <= this.maxPhoneWidth ||
            document.documentElement.clientWidth <= this.maxPhoneWidth ||
            document.body.clientWidth <= this.maxPhoneWidth
        ) {
            this.isPhone = true;
            this.isRequestDetailsShowOnPhone = false;
            this.isRequestListShowOnPhone = true;
        } else {
            this.isPhone = false;
            this.isRequestDetailsShowOnPhone = true;
            this.isRequestListShowOnPhone = true;
        }

        this.activatedRoute.queryParams.subscribe((params) => {
            this.searchParams.requestStatus = params['requestStatus'] || '';
            this.searchParams.resultFileStatus = params['resultFileStatus'] || '';
            this.searchParams.isLinkExpired = params['isLinkExpired'] || '';
            this.searchParams.skip = 0;
            this.requests.length = 0;

            if (
                this.searchParams.requestStatus ||
                this.searchParams.resultFileStatus ||
                this.searchParams.isLinkExpired
            ) {
                this.allRequestsRouterLinkActiveOptions = { exact: true };
            } else {
                this.allRequestsRouterLinkActiveOptions = { exact: false };
            }

            this.getRequests();
        });

        this.searchQuerySubscription = this.componentMessengerService.searchQueryMessage.subscribe((query) => {
            this.requests.length = 0;
            this.searchParams.query = query;
            this.getRequests();
        });

        this.messageSubscription = this.componentMessengerService.requestsMessage.subscribe((isNewRequestCreated) => {
            if (isNewRequestCreated) {
                this.getNewRequest();
            }
        });

        this.messageSubscription = this.componentMessengerService.requestViewMessage.subscribe((isRequestOpened) => {
            if (isRequestOpened) {
                this.showRequestDetail();
            } else {
                this.showRequestList();
            }
        });
    }

    showRequestDetail() {
        if (this.isPhone === true) {
            this.isRequestDetailsShowOnPhone = true;
            this.isRequestListShowOnPhone = false;
        }
    }

    showRequestList() {
        if (this.isPhone === true) {
            this.isRequestDetailsShowOnPhone = false;
            this.isRequestListShowOnPhone = true;
        }
    }

    getNewRequest(): void {
        const searchParams = Object.assign({}, this.searchParams);
        searchParams.take = 1;
        searchParams.skip = 0;
        searchParams.isLinkExpired = false;
        searchParams.query = '';
        searchParams.resultFileStatus = '';
        searchParams.requestStatus = this.personalDataRequestStatusEnum.created.toString();

        this.isLoading = true;
        this.requestService
            .getRequests(searchParams)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe((requests) => {
                this.requests.unshift(requests[0]);
                this.router.navigate(['detail', requests[0].id], {
                    queryParams: {
                        requestStatus: this.personalDataRequestStatusEnum.created,
                    },
                    relativeTo: this.activatedRoute,
                });
            });
    }

    getRequests(skip?: number): void {
        this.componentMessengerService.requestOpened(false);
        if (this.isLoading) {
            return;
        }
        if (!skip) {
            this.searchParams.skip = 0;
        }

        this.isLoading = true;
        this.requestService
            .getRequests(this.searchParams)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe((requests) => {
                Array.prototype.push.apply(this.requests, requests);
            });
    }

    openRequestModal() {
        const initialState = {};

        this.bsModalService.show(ModalNewRequestComponent, {
            initialState,
            ignoreBackdropClick: true,
        });
    }

    onScroll(): void {
        if (this.requests.length === this.searchParams.skip) {
            return;
        }
        this.searchParams.skip = this.requests.length;
        this.getRequests(this.searchParams.skip);
    }

    onSelect(request: Request): void {
        this.selectedRequest = request;
    }
}
